import type { ProfileSnapshot } from './profile';
import type { Action } from './types';

/** What the client sends to the server after a run. The server replays it and recomputes the score. */
export interface RunSubmission {
  mapId: string;
  /** e.g. "2026-09-23:map01". The server derives the seed from it, the client never sends a raw seed. */
  seedLabel: string;
  actions: Action[];
  claimedScore: number;
  /** Profile levels the run was played with. Omitted = base levels. */
  snapshot?: ProfileSnapshot;
}

export const MAX_ACTIONS_PER_RUN = 5000;

export const SEED_LABEL_RE = /^(\d{4}-\d{2}-\d{2}):([a-z0-9_-]{1,32})$/;

export function utcDay(now: number = Date.now()): string {
  return new Date(now).toISOString().slice(0, 10);
}

export function dailySeedLabel(mapId: string, now: number = Date.now()): string {
  return `${utcDay(now)}:${mapId}`;
}
